import { IDatasourceSQLMap } from 'src/app/utils/datasource-sql-map/datasource';
import { DatasourceSpecificColumnsSQLStatementsCompiler } from 'src/app/utils/datasource-sql-map/datasource-specific-sql-statements-compiler';
import { DatePickerSqlTokensCompiler } from 'src/app/utils/datasource-sql-map/date-picker-sql-tokens-compiler';
import { multipleSelectComponentCompileSQLTokens } from 'src/app/utils/datasource-sql-map/utils';

export class BiStgSkanDecodedPostbacks {
    public static get sqlMap() {
        const sqlMap: IDatasourceSQLMap = {
            dataset: 'bi_stg',
            tableId: 'skan_decoded_postbacks',
            columns: {
                ATTRIBUTION_CAMPAIGN_NAME: {
                    columnId: 'ATTRIBUTION_CAMPAIGN_NAME',
                    columnSQL: 'unified_campaign',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'unified_campaign',
                            state
                        );
                    },
                },
                SKAD_CONVERSION_VALUE: {
                    columnId: 'SKAD_CONVERSION_VALUE',
                    columnSQL: 'conversion_value',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'conversion_value',
                            state
                        );
                    },
                },
                ACTIVITY_DATE: {
                    columnId: 'ACTIVITY_DATE',
                    columnSQL: 'postback_date',
                    compileSQLTokens: (state) => {
                        return DatePickerSqlTokensCompiler.compileTokens(
                            'postback_date',
                            state
                        );
                    },
                },
                ATTRIBUTION_NETWORK_NAME: {
                    columnId: 'ATTRIBUTION_NETWORK_NAME',
                    columnSQL: 'unified_network',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'unified_network',
                            state
                        );
                    },
                },
                SKAD_POSTBACK_SOURCE: {
                    columnId: 'SKAD_POSTBACK_SOURCE',
                    columnSQL: 'source',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'source',
                            state
                        );
                    },
                },
            },
        };
        return sqlMap;
    }

    public static get sqlStatementsCompiler() {
        return new DatasourceSpecificColumnsSQLStatementsCompiler({
            sqlMap: BiStgSkanDecodedPostbacks.sqlMap,
            specificColumns: [
                /*'ATTRIBUTION_CAMPAIGN_NAME',
                'SKAD_CONVERSION_VALUE',
                'ACTIVITY_DATE',*/
            ],
            datasourcePrefix: 'postbacks',
        });
    }
}
